const styles = {
  container: 'relative -translate-y-16 group',
  backdrop:
    'absolute left-0 right-0 top-0 bottom-0 opacity-20 bg-black dark:bg-white',
  gradient: `absolute left-0 top-0 right-0 bottom-0 bg-gradient-to-t to-transparent pointer-events-none opacity-60`,

  body: {
    container: 'relative h-[86vh]',

    background: {
      container: 'absolute top-0 left-0 bottom-0 right-0 -z-1',
    },

    video: {
      container: 'flex items-center justify-center relative translate-y-80',
      // 'absolute top-0 left-0 bottom-0 right-0 flex items-center justify-center group',
    },

    content: {
      container: 'absolute top-0 left-0 bottom-0 right-0 flex flex-col',
      // container: 'z-20',

      head: 'bg-white font-medium',
      foot: ' grow flex flex-col justify-end pointer-events-none max-w-4xl',
    },

    icon: 'text-white text-7xl z-30 cursor-pointer hover:scale-110 transition-all duration-300 -translate-y-14 sm:translate-y-0',
    figure: 'relative aspect-video bg-black',
    image: 'object-cover duration-1000',

    actions: {
      container: 'md:absolute right-0 bottom-0 md:max-w-[24rem] w-full',
      button: {
        content: 'flex flex-row items-center justify-center gap-x-2 uppercase',
      },
    },
  },

  link: 'flex items-center gap-2 !z-20',
  icon: 'text-xs',
  label: 'hover:underline',
  title:
    'text-white text-base xl:text-2xl font-black tracking-tight max-w-[12rem] sm:max-w-[19rem] bg-black p-2 sm:p-4 uppercase mb-3 mt-2 sm:mb-4 mt-2',
  subtitle: 'text-white text-sm lg:text-xl tracking-tight bg-black p-2',
  date: 'text-xs sm:text-lg flex items-center gap-x-2 uppercase text-black bg-white dark:bg-black dark:text-white px-3 py-2',

  dialog: {
    content:
      'max-w-4xl xl:max-w-[67rem] xl:h-[37.5rem] !p-0 !border-none overflow-hidden',
  },

  button: {
    primary:
      'p-4 sm:p-8 bg-white dark:text-black hover:bg-black w-full font-bold cursor-pointer duration-200 hover:!text-white text-base',
    secondary:
      'p-4 sm:p-5 w-full text-white font-bold cursor-pointer hover:bg-black hover:!text-white duration-200 hover:!bg-black',
  },

  logo: 'absolute left-0 top-0 right-0 bottom-0 flex items-center justify-center duration-300',
};

export default styles;
